T.TeamEditor = Class(
	/**
	 * @lends {T.TeamEditor#}
	 */
	{
		_users: {},
		_invites: {},

		/** @type {DR.events.struct.Event} */
		event: null,
		/** @type {DR.users.struct.User} */
		user: null,
		/** @type {DR.teams.struct.Team} */
		team: null,

		__construct: function(event, user, team){
			this.event = event;
			this.user = user;
			this.team = team || null;

			this.node = mkE({
				tag: 'div',
				id: 'team-editor',
				els: [
					this.contentNode = mkE({
						tag: 'div',
						className: 'team-editor-content'
					})
				]
			});

			this.rpc = new RPC('/api/web_rpc.php?EVENT_ID=' + this.event.id);

			this.isCaptain = this.team && this.team.captain.id === this.user.id;
			this._draw();
		},

		_draw: function(){
			if( this.event.maxPlayers === 1 ){
				this._drawYahoo();
			} else if( this.team ){
				this._drawTeam();
			} else if( this.event.status === 'registration' ){
				this._drawCreateTeam();
			} else{
				this._drawEventOver();
			}
		},

		_drawEventOver: function(){
			mkE({
				tag: 'div',
				className: 'team-editor-create',
				els: [
					{
						tag: 'h2',
						els: [
							D.Lang.get('profile.welcome.hello') + ', ',
							this.user.name,
							'!'
						]
					},
					{
						tag: 'p',
						className: 'communities',
						innerHTML: D.Lang.get('profile.welcome.communities')
							.replace('%FACEBOOK%', '<a href="https://www.facebook.com/groups/372731283336637" target="_blank">facebook</a>')
					}
				]
			}).append(this.contentNode);
		},

		_drawYahoo: function(){
			mkE({
				tag: 'div',
				className: 'profile-team-success',
				els: [
					{
						tag: 'div',
						className: 'arrow'
					},
					{
						tag: 'h1',
						text: D.Lang.get('profile.team.completed.single.title')
					},
					{
						tag: 'p',
						text: D.Lang.get('profile.team.completed.single.description').replace('%DATE%', new D.Date(this.event.startTime).format('j. %L'))
					},
					new T.Download()
				]
			}).append(this.contentNode);
		},

		_drawCreateTeam: function(){
			mkE({
				tag: 'div',
				className: 'team-editor-create',
				els: [
					{
						tag: 'h2',
						els: [
							D.Lang.get('profile.welcome.hello') + ', ',
							this.user.name,
							'!'
						]
					},
					{
						tag: 'p',
						text: D.Lang.get('profile.welcome.description')
					},
					{
						tag: 'div',
						className: 'button-container',
						els: [
							{
								tag: 'a',
								className: 'button button-pink button-large',
								text: D.Lang.get('profile.welcome.button'),
								href: D.url('/profile/event/' + this.event.seoTitle + '/create')
							}
						]
					},
					{
						tag: 'p',
						className: 'communities',
						innerHTML: D.Lang.get('profile.welcome.communities')
							.replace('%FACEBOOK%', '<a href="https://www.facebook.com/groups/372731283336637" target="_blank">facebook</a>')
					}
				]
			}).append(this.contentNode);
		},

		_drawTeam: function(){
			let infoNode = mkE({
				tag: 'div',
				className: 'team-editor-info',
				els: [
					this._picUploadNode = mkE({
						tag: 'div',
						className: 'pic-upload',
						els: [
							new T.ProfilePic({
								type: 4,
								id: this.team.id,
								image: this.team.hasImage ? this.team.image.medium : null,
								defaultImage: '/assets/images/default/m_team.jpg',
								canChange: this.team.canChangeImage,
								errorHandler: this._picError
							})
						]
					})
				]
			}).append(this.contentNode);

			let dataNode = mkE({
				tag: 'div',
				className: 'team-editor-data'
			}).append(infoNode);

			mkE({
				tag: 'div',
				className: 'label',
				text: D.Lang.get('profile.team.editTitle.label')
			}).append(dataNode);

			if( this.team.canChangeTitle ){
				new T.Form.InputEdit({
					onSave: this._changeTeamName,
					canEdit: true,
					saveCaption: D.Lang.get('profile.team.editTitle.save'),
					value: this.team.title,
					small: true,
					attr: {
						maxLength: 16
					},
					fullClick: true,
					help: this.event.settings.type === 'race' ? D.Lang.get('profile.team.create.help')
						.replace('%REGISTRATION_CLOSE_DATE%', (new D.Date(this.event.registrationDate - 1)).format('j. %J')) : ''
				}).append(dataNode);
			} else{
				mkE({
					tag: 'h3',
					text: this.team.title
				}).append(dataNode);
			}

			mkE({
				tag: 'div',
				className: 'label',
				text: D.Lang.get('profile.team.users.label')
			}).append(dataNode);

			this._usersNode = mkE({
				tag: 'div',
				className: 'team-editor-users'
			}).append(dataNode);

			for( let i = 0, l = this.team.users.length; i < l; i++ ){
				let user = this.team.users[i];
				let userNode = mkE({
					tag: 'div',
					className: 'team-editor-user' + (user.id === this.team.captain.id ? ' captain' : ''),
					els: [
						{
							tag: 'span',
							text: user.name + ' ' + user.surname
						}
					]
				}).append(this._usersNode);

				if( this.team.canChangeUsers && user.id !== this.team.captain.id ){
					let optionsNode = mkE({
						tag: 'a',
						className: 'dots'
					}).append(userNode);

					tippy(optionsNode, {
						theme: 'light',
						trigger: 'click',
						placement: 'bottom',
						interactive: true,
						content: mkE({
							tag: 'div',
							className: 'user-options',
							els: [
								{
									tag: 'a',
									text: D.Lang.get('profile.team.users.captain'),
									onclick: D.closure(this, this._setCaptain, user.id, optionsNode)
								},
								{
									tag: 'a',
									text: D.Lang.get('profile.team.users.remove'),
									onclick: D.closure(this, this._removeUser, user.id, optionsNode)
								}
							]
						}),
						arrow: true
					});
				}

				this._users[user.id] = userNode;
			}

			for( let i = 0, l = this.team.invites.length; i < l; i++ ){
				let email = this.team.invites[i];
				let userNode = mkE({
					tag: 'div',
					className: 'team-editor-user invited',
					els: [
						{
							tag: 'span',
							text: email
						}
					]
				}).append(this._usersNode);
				if( this.team.canChangeUsers ){
					mkE({
						tag: 'a',
						className: 'remove',
						onclick: D.closure(this, this._removeInvite, email)
					}).append(userNode);
				}
				this._invites[email] = userNode;
			}

			if( this.team.canChangeUsers ){
				let currentUsers = this.team.users.length + this.team.invites.length;
				if( currentUsers < this.team.maxPlayers ){
					this._inviter = new T.TeamEditor.Inviter(this.event);
					this._inviter.setMax(this.team.maxPlayers - currentUsers);
					this._inviter._invitesSent = this._onInvitesSent;
					this._inviter.append(dataNode);
				}
			}

			if( D.DEV ){
				this._deleteNode = mkE({
					tag: 'div',
					className: 'delete',
					els: [
						{
							tag: 'a',
							onclick: this._deleteTeam,
							text: D.Lang.get('profile.team.delete') + ' (DEV)'
						}
					]
				}).append(dataNode);
			}
		},

		_picError: function(error){
			if( this._picErrorNode ){
				this._picErrorNode.remove();
				delete this._picErrorNode;
			}
			if( error ){
				this._picErrorNode = mkE({
					tag: 'div',
					className: 'pic-error',
					text: error
				}).append(this._picUploadNode);
			}
		},

		_changeTeamName: function(value, saveCb, errorCb){
			if( empty(value) ){
				errorCb(D.Lang.get('profile.team.create.errors.empty'));
				return;
			}
			this.rpc.send('changeTeamTitle', {
				title: value
			}, D.closure(this, this._onChangeTeamName, saveCb, errorCb));
		},

		_onChangeTeamName: function(saveCb, errorCb, data){
			if( data.error ){
				errorCb(D.Lang.get('profile.team.create.errors.' + data.error));
				return;
			}
			saveCb(data.title);
		},

		_setCaptain: function(userId, element){
			if( !confirm(D.Lang.get('profile.team.users.captainConfirm')) ){
				return;
			}
			element._tippy.hide();
			this.rpc.send('setCaptain', {
				id: userId
			}, D.closure(this, this._onSetCaptain, userId));
		},

		_onSetCaptain: function(userId, data){
			if( !data.ok || !this._users[userId] ){
				return;
			}
			D.reload();
		},

		_removeUser: function(userId, element){
			if( !confirm(D.Lang.get('profile.team.users.removeConfirm')) ){
				return;
			}
			element._tippy.hide();
			this.rpc.send('removeTeammate', {
				id: userId
			}, D.closure(this, this._onRemoveUser, userId));
		},

		_onRemoveUser: function(userId, data){
			if( !data.ok || !this._users[userId] ){
				return;
			}
			this._users[userId].remove();
			delete this._users[userId];
			this._checkInviter();
		},

		_checkInviter: function(){
			let currentUsers = this._usersNode.childNodes.length;
			let canAdd = this.team.maxPlayers - currentUsers;
			if( canAdd ){
				if( this._inviter ){
					this._inviter.setMax(canAdd);
				} else{
					this._inviter = new T.TeamEditor.Inviter(this.event);
					this._inviter.setMax(canAdd);
					this._inviter._invitesSent = this._onInvitesSent;
					D.insertBefore(this._inviter.node, this._deleteNode);
				}
			} else if( this._inviter ){
				this._inviter.remove();
				delete this._inviter();
			}
		},

		_removeInvite: function(email){
			if( !confirm(D.Lang.get('profile.team.users.removeInviteConfirm')) ){
				return;
			}
			this.rpc.send('removeInvite', {
				email: email
			}, D.closure(this, this._onRemoveInvite, email));
		},

		_onRemoveInvite: function(email, data){
			if( !data.ok || !this._invites[email] ){
				return;
			}
			this._invites[email].remove();
			delete this._invites[email];
			this._checkInviter();
		},

		_deleteTeam: function(){
			if( this._isDeleting ){
				return;
			}
			this._isDeleting = true;
			if( !confirm(D.Lang.get('profile.team.delete_confirm')) ){
				return;
			}
			this.rpc.send('deleteTeam', {}, this._onDeleteTeam);
		},

		_onDeleteTeam: function(){
			D.reload();
		},

		_onInvitesSent: function(emails){
			for( let i = 0, l = emails.length; i < l; i++ ){
				let email = emails[i];
				if( this._invites[email] ){
					continue;
				}
				let userNode = mkE({
					tag: 'div',
					className: 'team-editor-user invited',
					els: [
						{
							tag: 'span',
							text: email
						}
					]
				}).append(this._usersNode);
				if( this.isCaptain ){
					mkE({
						tag: 'a',
						className: 'remove',
						onclick: D.closure(this, this._removeInvite, email)
					}).append(userNode);
				}
				this._invites[email] = userNode;
			}
			this._checkInviter();
		}
	},
	mkE.Base
);

/**
 * @class {T.TeamEditor.Inviter}
 * @extends {mkE.Base}
 */
T.TeamEditor.Inviter = Class(
	/**
	 * @lends {T.TeamEditor.Inviter#}
	 */
	{
		_maxUsers: 1,
		_inputs: [],
		_addDisabled: true,
		_sendDisabled: true,

		/**
		 * @constructs
		 */
		__construct: function(event){
			this.event = event;

			this.node = mkE({
				tag: 'div',
				className: 'team-editor-inviter',
				els: [
					this._inputContainer = mkE({
						tag: 'div',
						className: 'emails'
					}),
					{
						tag: 'div',
						className: 'buttons',
						els: [
							this._addButton = mkE({
								tag: 'a',
								className: 'add-input disabled',
								onclick: this._addInput,
								text: D.Lang.get('profile.team.inviter.add')
							}),
							this._sendButton = mkE({
								tag: 'a',
								className: 'send-invites disabled',
								onclick: this._sendInvites,
								text: D.Lang.get('profile.team.inviter.send')
							})
						]
					}
				]
			});

			this.rpc = new RPC('/api/web_rpc.php?EVENT_ID=' + this.event.id);

			this._refreshAddButton();
			this._refreshSendButton();
		},

		setMax: function(max){
			this._maxUsers = max;
			this._refreshAddButton();
		},

		_refreshAddButton: function(){
			if( this._inputs.length >= this._maxUsers ){
				addClassName(this._addButton, 'disabled');
				this._addDisabled = true;
			} else{
				removeClassName(this._addButton, 'disabled');
				this._addDisabled = false;
			}
		},

		_refreshSendButton: function(){
			let active = false;
			for( let i = 0, l = this._inputs.length; i < l; i++ ){
				if( !empty(this._inputs[i].value()) ){
					active = true;
					break;
				}
			}
			if( !active ){
				addClassName(this._sendButton, 'disabled');
				this._sendDisabled = true;
			} else{
				removeClassName(this._sendButton, 'disabled');
				this._sendDisabled = false;
			}
		},

		_addInput: function(){
			if( this._addDisabled ){
				return;
			}
			let input = new T.Form.Input({
				type: 'email',
				border: true,
				placeholder: D.Lang.get('profile.team.inviter.placeholder'),
				onKeyUp: this._refreshSendButton,
				onChange: this._refreshSendButton,
				attr: {
					maxLength: 254
				}
			});
			input.append(this._inputContainer);
			this._inputs.push(input);
			this._refreshAddButton();
		},

		_sendInvites: function(){
			if( this._isSending || this._sendDisabled ){
				return;
			}
			if( this._successNode ){
				this._successNode.remove();
				delete this._successNode;
			}
			let emails = {};
			for( let i = 0, l = this._inputs.length; i < l; i++ ){
				this._inputs[i].error(null);
				let value = this._inputs[i].value();
				if( empty(value) ){
					continue;
				}
				emails[i] = value;
			}
			if( empty(emails) ){
				return;
			}
			this._isSending = true;
			this.rpc.send('inviteUsers', {
				emails: emails
			}, this._onSendInvites);
		},

		_onSendInvites: function(data){
			this._isSending = false;
			if( data.ok ){
				this._successNode = mkE({
					tag: 'div',
					className: 'success',
					text: D.Lang.get('profile.team.inviter.success')
				}).prepend(this.node);
				this._inputs = [];
				clearNode(this._inputContainer);
				this._refreshAddButton();
				this._refreshSendButton();
				this._invitesSent(data.emails);
			} else if( data.errors ){
				for( let i = 0, l = data.errors.length; i < l; i++ ){
					let index = data.errors[i];
					if( this._inputs[index] ){
						this._inputs[index].error(D.Lang.get('profile.team.invite.error'));
					}
				}
			}
		},

		_invitesSent: function(emails){

		}
	},
	mkE.Base
);
